module.exports = __webpack_public_path__ + "img/1_upays-glink.dfcb5692.png";